import React, { Component } from "react";
import PropTypes from "prop-types";
import LineSeries from "./LineSeries";
import StraightLine from "./StraightLine";

class PsySeries extends Component {
  render() {
    const { className, stroke, onContextMenu } = this.props;
    const { yAccessor } = this.props;
    const { overSold, middle, overBought } = this.props;

    // Extract numeric values and stroke properties from ThresholdLineType objects
    const extractThresholdValue = (prop, defaultValue, defaultStroke) => {
      if (typeof prop === "number") {
        return { value: prop, stroke: defaultStroke };
      }
      if (prop && typeof prop === "object") {
        if (prop.value !== undefined && prop.stroke) {
          return { value: prop.value, stroke: prop.stroke };
        }
        const keys = Object.keys(prop);
        if (keys.length === 1) {
          return { value: prop[keys[0]], stroke: defaultStroke };
        }
        if (prop.value !== undefined) {
          return { value: prop.value, stroke: defaultStroke };
        }
        if (prop.defaultValue !== undefined) {
          return { value: prop.defaultValue, stroke: defaultStroke };
        }
      }
      return { value: defaultValue, stroke: defaultStroke };
    };

    const overBoughtData = extractThresholdValue(overBought, 75, {
      color: "#0000FF",
      dash: "Dash",
      width: 1,
      opacity: 1,
    });
    const overSoldData = extractThresholdValue(overSold, 25, {
      color: "#FF0000",
      dash: "Dash",
      width: 1,
      opacity: 1,
    });
    const middleData = middle
      ? extractThresholdValue(middle, 50, {
          color: "#8795A1",
          dash: "Dash",
          width: 1,
          opacity: 1,
        })
      : null;

    // Handle stroke for main PSY line
    const psyStroke = stroke.line ? stroke.line : stroke;

    return (
      <g className={className}>
        {/* Threshold lines */}
        <StraightLine
          stroke={overSoldData.stroke}
          yValue={overSoldData.value}
          onContextMenu={onContextMenu}
        />
        {middleData && (
          <StraightLine
            stroke={middleData.stroke}
            yValue={middleData.value}
            onContextMenu={onContextMenu}
          />
        )}
        <StraightLine
          stroke={overBoughtData.stroke}
          yValue={overBoughtData.value}
          onContextMenu={onContextMenu}
        />
        {/* Main PSY line */}
        <LineSeries
          className={className}
          yAccessor={yAccessor}
          stroke={psyStroke}
          onContextMenu={onContextMenu}
        />
      </g>
    );
  }
}

PsySeries.propTypes = {
  className: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  stroke: PropTypes.oneOfType([
    PropTypes.shape({
      color: PropTypes.string,
      dash: PropTypes.string,
      width: PropTypes.number,
      opacity: PropTypes.number,
    }),
    PropTypes.shape({
      line: PropTypes.shape({
        color: PropTypes.string,
        dash: PropTypes.string,
        width: PropTypes.number,
        opacity: PropTypes.number,
      }),
    }),
  ]),
  overSold: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  middle: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  overBought: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  onContextMenu: PropTypes.func,
};

PsySeries.defaultProps = {
  className: "react-stockcharts-psy-series",
  stroke: {
    color: "#FF6B6B",
    dash: "Solid",
    width: 1,
    opacity: 1,
  },
};

export default PsySeries;
